import * as S from "./BoardDetail.style";
import DOMPurify from "dompurify";

interface BoardDetailProps {
  date: any;
  title: string;
  content: any;
  category: string;
}

export const BoardDetail = ({
  date,
  title,
  content,
  category = "게시글 타입을 설정하지 않았습니다.",
}: BoardDetailProps) => {
  const safeContent = DOMPurify.sanitize(content);

  return (
    <S.BoardDetail>
      <S.BoardTitleBox>
        <span>{category}</span>
        {title}
      </S.BoardTitleBox>

      <S.BoardContentBox>
        <div dangerouslySetInnerHTML={{ __html: safeContent }} />
      </S.BoardContentBox>

      <S.BoardInfoBox>{date}</S.BoardInfoBox>
    </S.BoardDetail>
  );
};
